import { Component, OnInit } from "@angular/core";
import { ShareVars } from "@app/shared/services/share.vars";
import { LoginService } from "@app/shared/services/login.service";
import { BaseService } from "@app/shared/services/base.service";
import { NavigationService } from "@app/shared/services/navigation.service";
import { HOME_ROUTE } from "@app/shared/services/routes.pages";

@Component({
    selector: "app-oauth-callback",
    templateUrl: "./oauth-callback.component.html",
    styleUrls: ["./oauth-callback.component.scss"],
})
export class OauthCallbackComponent implements OnInit {
    showError = false;
    constructor(
        private loginService: LoginService,
        private baseService: BaseService,
        private navigationService: NavigationService
    ) {
        ShareVars.isBusy = true;
    }

    ngOnInit() {
		this.initCallback();
    }

	initCallback() {
		const params = new URLSearchParams(window.location.search);
		if (!params.has("code")) {
            ShareVars.isBusy = false;
            this.showError = true;
			return;
		}
		this.loginService.authenticateWithGoogle({
            code: params.get("code"),
            scope: params.get("scope"),
            authuser: params.get("authuser"),
            prompt: params.get("prompt"),
            redirect_uri: window.location.origin + "/google/oauth",
        }).subscribe(
			( data: any ) => {
                if (!data.user && !data.user.token) {
                    ShareVars.isBusy = false;
                    this.showError = true;
                    return;
                }
                localStorage.setItem("loginProvider","Guest")
                this.baseService.setToken(data.user.token)
                window.location.href = localStorage.getItem('oauth_return_path') || HOME_ROUTE;
			},
			(error) => {
			}
		);		
	}
	
    goHome(){
        this.navigationService.goToHomePage()
    }
}